import { React, lazy } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import Loader from '../components/Loader/Loader';

const Header = lazy(() => import('../components/Header/Header'));
const Footer = lazy(() => import('../components/Footer/DashFooter'));
const Menu = lazy(() => import('../components/LeftMenu/DashMenu'));
export default function Innerlayout() {
  const location = useLocation();

  return (
    <div>
      {/* <Suspense
        fallback={(
          <div>
            <Loader 
          </div>
        )}
      > */}
      <Header />
      {/* </Suspense> */}
      {/* <Suspense
        fallback={(
          <div>
            <Loader style={{ marginTop: '250px', marginLeft: '80px' }} />
          </div>
        )}
      > */}
      <Menu />
      {/* </Suspense> */}
      {/* <Suspense
        fallback={(
          <div>
            <Loader />
          </div>
        )}
      > */}
      <ErrorBoundary variant="page" resetKey={location.pathname}>
        <Outlet />
      </ErrorBoundary>
      {/* </Suspense> */}
      {/* <Suspense
        fallback={(
          <div>
            <Loader />
          </div>
        )}
      > */}
      <Footer />
      {/* </Suspense> */}
    </div>
  );
}
